module.exports = __webpack_public_path__ + "img/virtual_tour.701df725.jpg";